module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', [(_vm.toast) ? _h('mu-toast', {
    attrs: {
      "message": _vm.toastmessage
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), " ", _h('mu-appbar', {
    attrs: {
      "title": "產品列表"
    }
  }, [_h('mu-flat-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.auth),
      expression: "!auth"
    }],
    attrs: {
      "color": "white",
      "label": "Fb Login"
    },
    on: {
      "click": _vm.signIn
    },
    slot: "right"
  }), " ", _h('mu-flat-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auth),
      expression: "auth"
    }],
    attrs: {
      "color": "white",
      "label": "Sign Out"
    },
    on: {
      "click": _vm.signOut
    },
    slot: "right"
  })]), " ", _h('mu-content-block', [_h('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_h('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "33"
    }
  }, [_h('h1', ["所有物品"])])]), " ", _h('div', {
    staticClass: "demo-grid"
  }, [_h('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_vm._l((_vm.productDesc), function(product, index) {
    return (_vm.products.length > 0) ? _h('mu-col', {
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "33"
      }
    }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
      staticClass: "product-photo",
      attrs: {
        "src": product.productPhoto
      }
    })]), " ", _h('mu-card-title', {
      attrs: {
        "title": product.title,
        "subTitle": ' NT$' + product.price
      }
    }), " ", _h('mu-card-text', {
      staticClass: "text-align-left"
    }, ["\n                狀態：" + _vm._s(_vm.productState[index]), _h('br'), "\n                地點：" + _vm._s(product.address) + "\n                ", _h('pre', [_vm._s(product.description)])]), " ", _h('mu-card-text', {
      staticClass: "text-align-left"
    }, [_vm._l((_vm.productSplitArray[index]), function(keyword) {
      return _h('div', [_h('span', [_h('a', {
        attrs: {
          "href": '#' + keyword
        }
      }, ["#" + _vm._s(keyword)])])])
    })]), " ", _h('mu-card-header', {
      attrs: {
        "title": _vm.productCreateTime[index] + ' 前建立',
        "subTitle": '來自 ' + product.userName
      }
    }, [_h('mu-avatar', {
      attrs: {
        "src": product.userPhotoUrl
      },
      slot: "avatar"
    })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
      attrs: {
        "label": "INIT"
      },
      on: {
        "click": function($event) {
          _vm.updateProductState(product, 0)
        }
      }
    }), " ", _h('mu-flat-button', {
      attrs: {
        "label": "X18"
      },
      on: {
        "click": function($event) {
          _vm.updateProductState(product, 1)
        }
      }
    }), " ", _h('mu-flat-button', {
      attrs: {
        "label": "TEST"
      },
      on: {
        "click": function($event) {
          _vm.updateProductState(product, 2)
        }
      }
    }), " ", _h('mu-flat-button', {
      attrs: {
        "label": "DELETE"
      },
      on: {
        "click": function($event) {
          _vm.updateProductState(product, 3)
        }
      }
    })]), " "])]) : _vm._e()
  })])])]), " ", _h('mu-content-block', [_h('div', {
    staticClass: "demo-grid"
  }, [_h('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_h('mu-col', {
    attrs: {
      "width": "0",
      "tablet": "0",
      "desktop": "20"
    }
  }), " ", (_vm.auth) ? _h('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "30"
    }
  }, [_h('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "label": "上傳圖片"
    }
  }, [_h('input', {
    staticClass: "file-button",
    attrs: {
      "accept": "image/*,capture=camera",
      "type": "file"
    },
    on: {
      "change": _vm.saveImageMessage
    }
  })]), _h('br'), " ", _h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "label": "物品名稱",
      "type": "text",
      "errorText": (!_vm.title) ? '不可空白' : '',
      "labelFloat": ""
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        _vm.title = $event
      }
    }
  }), _h('br'), " ", _h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.price),
      expression: "price"
    }],
    attrs: {
      "label": "價格",
      "type": "number",
      "errorText": (!_vm.price) ? '不可空白' : '',
      "labelFloat": ""
    },
    domProps: {
      "value": (_vm.price)
    },
    on: {
      "input": function($event) {
        _vm.price = _vm._n($event)
      }
    }
  }), _h('br'), " ", _h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    attrs: {
      "label": "地點",
      "type": "text",
      "hintText": "如：台北市大安區",
      "labelFloat": ""
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        _vm.address = $event
      }
    }
  }), _h('br'), " ", _h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    attrs: {
      "hintText": "(選擇性填寫)敘述你要賣的物品吧，如：尺寸，顏色",
      "multiLine": "",
      "rows": 4
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        _vm.description = $event
      }
    }
  }), _h('br'), " ", _h('mu-text-field', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    attrs: {
      "label": "關鍵字",
      "type": "text",
      "hintText": "逗點分隔關鍵字，如：nike,puma...",
      "labelFloat": ""
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        _vm.keywords = $event
      }
    }
  }), _h('br'), " ", _h('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "label": "送出",
      "primary": ""
    },
    on: {
      "click": _vm.addProduct
    }
  })]) : _vm._e(), " ", _h('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "30"
    }
  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
    staticClass: "product-photo",
    attrs: {
      "src": _vm.productPhoto
    }
  })]), " ", _h('mu-card-title', {
    attrs: {
      "title": _vm.title,
      "subTitle": ' NT$' + _vm.price
    }
  }), " ", _h('mu-card-text', {
    staticClass: "text-align-left"
  }, ["\n                地點：" + _vm._s(_vm.address) + "\n                ", _h('pre', [_vm._s(_vm.description)])]), " ", _h('mu-card-text', {
    staticClass: "text-align-left"
  }, [_vm._l((_vm.splitArray), function(keyword) {
    return _h('div', [_h('span', [_h('a', {
      attrs: {
        "href": '#' + keyword
      }
    }, ["#" + _vm._s(keyword)])])])
  })]), " ", (_vm.auth) ? _h('mu-card-header', {
    attrs: {
      "title": "幾秒 前建立",
      "subTitle": '來自 ' + _vm.auth.displayName
    }
  }, [_h('mu-avatar', {
    attrs: {
      "src": _vm.auth.photoURL
    },
    slot: "avatar"
  })]) : _vm._e(), " ", _h('mu-card-actions', [(_vm.auth) ? _h('mu-flat-button', {
    attrs: {
      "label": '丟訊息問問 ' + _vm.auth.displayName
    }
  }) : _vm._e()])])]), " ", _h('mu-col', {
    attrs: {
      "width": "0",
      "tablet": "0",
      "desktop": "20"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39b15fa7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Home.vue
// module id = 91
// module chunks = 2